<template>
  <div id="calendar-callback-view">
    <header>
      <div class="icon">
        <h1>Shadow</h1>
      </div>
      <div v-if="loaded">
        <h2 v-if="success">Success!</h2>
        <h2 v-else>Failed to process the request</h2>
        <p>You may now close the window.</p>
      </div>
    </header>
    <main>
      <div class="btn-group-wrap" v-if="loaded">
        <button id="btn-open-shadow" @click="close">Return to App</button>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "CalendarCallbackView",
  data() {
    return {
      queryStringParameters: this.$route.query,
      success: false,
      loaded: false,
    };
  },
  async mounted() {
    if (this.checkQueryParams()) this.success = await this.registerCode();
    this.loaded = true;

    if (this.success && this.loaded) this.open();
  },
  methods: {
    checkQueryParams() {
      if (this.queryStringParameters.error) {
        console.error("ERROR: Failed to create user token.");
        return false;
      }
      const requiredParams = ["code", "state", "scope"];
      const requiredScopes = [
        "https://www.googleapis.com/auth/calendar.readonly",
      ];
      if (!requiredParams.every((p) => p in this.queryStringParameters)) {
        console.error(
          `ERROR: Missing query string parameters.\n${this.queryStringParameters}`
        );
        return false;
      }

      const receivedScopes = (this.queryStringParameters.scope || "")
        .trim()
        .split(" ")
        .filter(Boolean);

      if (!requiredScopes.every((scope) => receivedScopes.includes(scope))) {
        console.error(
          `ERROR: Required scopes not granted. Received: ${receivedScopes}`
        );
        return false;
      }

      return true;
    },
    async registerCode() {
      const apiUrl = new URL(
        "https://d3ea3io1axhl6i.cloudfront.net/dev/oauth2callback"
      );
      for (let k in this.queryStringParameters) {
        apiUrl.searchParams.append(k, this.queryStringParameters[k]);
      }
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Failed to create user token.`);
        }
        return true;
      } catch (error) {
        console.error(error.message);
        return false;
      }
    },
    open() {
      location.href = `shadow://${this.success ? "gcal-connect" : ""}`;
    },
    close() {
      this.open();
      window.close();
    },
  },
};
</script>

<style>
body:has(#calendar-callback-view) {
  background: #151515;
  color: #fff;
}
</style>

<style scoped>
#calendar-callback-view {
  max-width: 720px;
  margin: 0 auto;
  padding: 5.587% 6.9835%;
}

header {
  margin-bottom: 60px;
  text-align: center;
}

header .icon {
  margin-bottom: 60px;
}

header .icon h1 {
  width: 120px;
  height: 31.2px;
  text-indent: -9999px;
  margin: 0 auto;
  background-image: url("@/assets/img/logo.png");
  background-size: cover;
}

header h2 {
  margin-bottom: 30px;
  font-size: 32px;
  font-weight: 600;
}

header p {
  font-size: 18px;
  font-weight: 300;
  color: #ccc;
}

button {
  position: relative;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  padding: 0 12px;
  border: 1px solid #777;
  border-radius: 5px;
  color: #aaa;
  background-color: #1d2021;
  cursor: pointer;
  text-align: center;
}

div.btn-group-wrap {
  text-align: center;
}

div.btn-group-wrap button {
  font-size: 16px;
}

#btn-open-shadow {
  width: 240px;
  height: 40px;
  border: 1px solid #d65d0e;
  background: #d65d0e;
  color: #fff;
  font-weight: 600;
}
</style>
